
































































import Vue from 'vue';
import { ACTION_SET_TRUCK_CONFIG } from '../../../../store/modules/generic';

export default {
    data() {
        return {
            form: {},
            visible: false,
        };
    },
    mounted(this: any) {
        this.form = this.$store.getters.truckConfigurations;
    },
    methods: {
        onSubmit(this: any) {
            this.$store.commit(ACTION_SET_TRUCK_CONFIG, this.form);
            this.visible = false;
        },
        show(this: any) {
            this.visible = true;
        },
    },
};
